import './grid_section_desktop_layout.less';

import React from 'react';
import map from 'lodash/map';
import filter from 'lodash/filter';

import GridTileForDesktop from './grid_tile_for_desktop_container.jsx';

export default ({ gridPositions, section, tileLength, tilePadding, tileMargin, subpage, width })=>
  <div className="tiles-grid" style={{width: width}}>
    {
      map(
        filter(gridPositions, 'uuid'), 
        (gridPos) => (
          <GridTileForDesktop 
            key={gridPos.uuid || gridPos.eid}
            section={section}
            subpage={subpage}
            showActionOnHover={true}
            {...{ tileLength, tilePadding, tileMargin, ...gridPos }}
          />
        )
      )
    }
  </div>;
